import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a9cc58a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "SurveyVariant" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "SurveyVariant__text font-semibold" }
const _hoisted_5 = { class: "SurveyVariant__text ml-3" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-end"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))
const _hoisted_9 = { class: "SurveyVariant__bar mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.variant.title), 1),
        _createElementVNode("span", _hoisted_5, "Ответов: " + _toDisplayString(_ctx.variant.answersCount), 1)
      ]),
      (_ctx.isUpdate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_the_button, {
              class: "red small text mr-3",
              loading: _ctx.state.is_loading,
              onClick: _ctx.deleteVariant
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Удалить ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"]),
            _createVNode(_component_the_button, {
              class: "primary small text mr-2",
              onClick: _ctx.emitUpdate
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _createTextVNode(" Редактировать ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", {
        class: "SurveyVariant__answer",
        style: _normalizeStyle({ width: _ctx.computedPercent })
      }, null, 4)
    ])
  ]))
}